import { createAction, props } from '@ngrx/store';
import { CatalogsVehicleInterface } from './catalog-vehicle.models';
import { CatalogRequest } from '@core/services/common/catalog-operation';

export const loadCatalogsVehicle = createAction(
  '[CatalogsVehicle] Load',
  props<CatalogRequest & { userGuid: string }>(),
);

export const loadCatalogsVehicleSuccess = createAction(
  '[CatalogsVehicle] Load Success',
  props<CatalogRequest & { userGuid: string; catalogs: CatalogsVehicleInterface }>(),
);

export const loadCatalogsVehicleFailure = createAction(
  '[CatalogsVehicle] Load Failure',
  props<CatalogRequest & { error: string }>(),
);

export const resetCatalogsVehicle = createAction('[CatalogsVehicle] Reset');
export const refreshCatalogsVehicle = createAction('[CatalogsVehicle] Refresh');
